import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import Sift from "@/components/sift/Sift";
export default {
  name: "Serve",
  components: {
    Sift: Sift
  },
  props: [],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      siftData: [],
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  computed: _objectSpread({}, mapGetters(["userToken"])),
  created: function created() {},
  mounted: function mounted() {
    this.fetchSiftData();
  },
  destroyed: function destroyed() {},
  methods: {
    // 搜索框组件数据
    fetchSiftData: function fetchSiftData() {
      var _this = this;

      this.loading = true;
      setTimeout(function () {
        _this.siftData = [{
          type: "text",
          key: "name",
          label: "服务名称",
          placeholder: "",
          default: ""
        }, {
          type: "text",
          key: "title",
          label: "事务标题",
          placeholder: "",
          default: ""
        }];

        _this.$nextTick(function () {
          _this.initPage();
        });
      }, 500);
    },
    // 获取列表
    getListFn: function getListFn() {
      var _this2 = this;

      var selectData = this.$refs.needSift.getValue(); // 获取搜索条件的值

      var data = {
        serveName: selectData.name,
        proTitle: selectData.title,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      this.$http.get("/overtime/list", {
        params: data
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode === 0) {
          _this2.list = data.resData.list;
          _this2.total = data.resData.total;
        }

        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    // 详情
    goInfo: function goInfo(proId) {
      var urlArr = this.$http.defaults.baseURL.split(":");
      var url = urlArr[0] + urlArr[1] + ":8088/portal/r/w?sid=#{" + this.userToken + "}&cmd=CLIENT_BPM_FORM_MAIN_PAGE_OPEN&processInstId=#{" + proid + "}";
      window.location = url;
    },
    // 默认页面数据
    initPage: function initPage() {
      this.pageNum = 1;
      this.getListFn();
    },
    // 条数
    changeSize: function changeSize(value) {
      this.pageSize = value;
      this.getListFn();
    },
    // 上下页
    changePage: function changePage(value) {
      this.pageNum = value;
      this.getListFn();
    }
  },
  watch: {},
  filters: {}
};